import type { AuthSession } from "aws-amplify/auth";

// Cognito only lets an access token call self-service APIs (passkeys, TOTP,
// MFA preference, GetUser) when it carries this scope. The pre token
// generation trigger removes it from refreshed tokens, so its presence means
// the user signed in recently.
const selfServiceScope = "aws.cognito.signin.user.admin";

export function hasSelfServiceScope(session: AuthSession): boolean {
	const scope = session.tokens?.accessToken.payload.scope;
	if (typeof scope !== "string") {
		return false;
	}
	return scope.split(" ").includes(selfServiceScope);
}
